<template>
	<v-row>
		<BottomNavigationContainer v-if="menu.length > 1" :menu="menu" />

		<v-col cols="12" class="d-none d-md-block">
			<ToolbarContainer :menu="menu" />
			<v-toolbar elevation="1" height="25" rounded="b">
				<Breadcrumbs />
			</v-toolbar>
		</v-col>

		<v-col cols="12" lg="12">
			<router-view />
		</v-col>
	</v-row>
</template>

<script>
import Breadcrumbs from "../Widgets/Breadcrumbs";
import ToolbarContainer from "../Widgets/ToolbarContainer";
import BottomNavigationContainer from "../Widgets/BottomNavigationContainer";

export default {
	name: "ConcretoContainer",
	components: { Breadcrumbs, ToolbarContainer, BottomNavigationContainer },
	data: () => ({
		menu: [],
		drawer: false,
		group: null,
		value: 0,
	}),
	methods: {
		montarMenu() {
			let m = [];

			if (this.permissao("concreto_listar")) {
				m.push({
					titulo: "* Venda de concreto",
					titulo_app: "Vendas",
					icon: "mdi-shopping-outline",
					to: "/concreto",
					tooltip: "Tele-vendas de concreto",
				});
			}

			if (this.permissao("concreto_agendamento")) {
				m.push({
					titulo: "* Agendamento de concreto",
					titulo_app: "Agendamento",
					icon: "mdi-shopping-outline",
					to: "/concreto/agendamento",
					tooltip: "Agendamento de concreto",
				});
			}

			if (this.permissao("concreto_listar")) {
				m.push({
					titulo: "* Pedidos",
					titulo_app: "Pedidos",
					icon: "mdi-shopping-outline",
					to: "/concreto/pedido",
					tooltip: "Lista de pedidos de concreto",
				});
			}

			this.menu = m;
		},
	},
	mounted() {
		this.montarMenu();
	},
};
</script>

<style scoped>
</style>